// extracted by mini-css-extract-plugin
module.exports = {"container":"availabilityIcon_container__1mW5l","active":"availabilityIcon_active__3f9cR"};